<template>
    <Modal :open="open" :show-close-icon="true" @close="closeModal" :is-card="true" :narrow="false">
        <h2 class="apply-for-finance-modal__title" v-if="type == 'Apply'">Apply for Finance</h2>
        <h2 class="apply-for-finance-modal__title" v-else>Free Credit Check</h2>
        <p v-if="type == 'Apply'">In order to start your finance application, please select your nearest dealer</p>
        <p v-else>In order to start your Free Credit Check, please select your nearest dealer</p>

        <form @submit.prevent="submit" ref="form">
            <div class="form-grid form-grid--xs-1-column">
                <div class="form-grid__col form-grid__col--xs-full-width">
                    <customer-location />
                </div>
                <div class="form-grid__col form-grid__col--xs-full-width">
                    <dealer :filter-new="true" />
                </div>
                <div class="form-grid__col-span-2 form-grid__col--xs-full-width" style="justify-self: center;">
                    <LoadingSpinner v-if="loading"></LoadingSpinner>
                    <button v-else type="submit" class="btn btn--primary btn--min-width">Continue</button>
                </div>
            </div>
        </form>
    </Modal>
</template>

<script>
import Modal from "../../core/components/Modal.vue";
import CustomerLocation from "../../core/components/Forms/CustomerLocation.vue";
import Dealer from "../../core/components/Forms/Dealer.vue";
import { mapState } from "vuex";
import ContactFormValidator from "../../validation/ContactFormValidator";
import CustomerLocationHandler from "../../modules/CustomerLocationHandler";
import { customEvent } from '../../modules/tracking/AnalyticsEvents';

export default {
    props: {
        open: {
            default: false,
        },
        financeKey: {
            required: true,
        },
        type: {
            required: true,
        },
    },
    components: {
        Modal,
        CustomerLocation,
        Dealer,
    },
    data() {
        return {
            validator: null,
            customerLocationHandler: null,
            loading: false,
        };
    },
    methods: {
        closeModal() {
            this.$emit("close-modal");
        },

        async submit() {
            if (!await this.validator.isValid()) {
                return;
            }
            this.loading = true;
            const formData = new FormData(this.$refs.form);
            const locationId = formData.get('location-id');
            for (let index = 0; index < this.customerLocationHandler.locationData.length; index++) {
                const location = this.customerLocationHandler.locationData[index];
                if (location.id == locationId) {
                    this.$store.commit('Finance/setSelectedDealerCodewaversKey', location.codeweavers_key);
                    break;
                }
            }

            customEvent("Configurator Final Screen", this.eventLabel, "Dealer selected");

            this.validator.preventInput();
            this.$store
                .dispatch("Finance/getFinanceQuoteForDealership", this.financeKey)
                .then(quotes => {
                    this.loading = false;
                    this.validator.allowInput();
                    customEvent("Configurator Final Screen", this.eventLabel, "Redirecting to Codeweavers");
                    if (quotes.length == 0) {
                        this.validator.errorResponse('Sorry, something has gone wrong');
                        return;
                    }
                    if (typeof quotes[0].FinanceProductResults == 'undefined') {
                        this.validator.errorResponse('Sorry, something has gone wrong');
                        return;
                    }
                    if (typeof quotes[0].FinanceProductResults[0] == 'undefined') {
                        this.validator.errorResponse('Sorry, something has gone wrong');
                        return;
                    }
                    if (typeof quotes[0].FinanceProductResults[0].Quote == 'undefined') {
                        this.validator.errorResponse('Sorry, we were unable to generate a quote for your chosen dealership');
                        return;
                    }
                    if (typeof quotes[0].FinanceProductResults[0].Quote.QuoteActions == 'undefined') {
                        this.validator.errorResponse('Sorry, we were unable to generate a quote for your chosen dealership');
                        return;
                    }
                    if (typeof quotes[0].FinanceProductResults[0].Quote.QuoteActions[this.type] == 'undefined') {
                        this.validator.errorResponse('Sorry, we were unable to generate a quote for your chosen dealership');
                        return;
                    }
                    window.open(quotes[0].FinanceProductResults[0].Quote.QuoteActions[this.type], '_blank');
                })
                .catch(error => {
                    customEvent("Configurator Final Screen", this.eventLabel, "Error regenerating quote for dealership");
                    this.loading = false;
                    console.error(error);
                    this.validator.errorResponse(error);
                });
        },
    },
    computed: {
        ...mapState(['brand']),
        eventLabel() {
            if (this.type == 'MotorCreditCheck') {
                return 'Free Credit Check';
            }
            return 'Apply For Finance';
        }
    },
    mounted() {
        this.validator = new ContactFormValidator({
            vueForm: true,
            redesign: true,
            element: this.$refs["form"],
        });
        this.customerLocationHandler = new CustomerLocationHandler({
            element: this.$refs["form"],
            additionalLocationFilterFunction: dealer => (dealer.brand == this.brand && dealer.codeweavers_key != null && dealer.codeweavers_key.length > 0)
        });
    },
};
</script>

<style lang="scss">
.apply-for-finance-modal {
    &__title {
        text-align: center;
        color: #192a44;
    }
}
</style>